import { useState } from "react";
import { Col, Row } from "antd";
import Plus from "components/icons/Plus";
import { useTranslation } from "react-i18next";
import ItemsCourse from "./Items";
import s from "./styles";
import { useBusinessContext } from "../../../../BusinessApp";

function Mix_Match({ items, setFieldValue, values, errors }) {
  const { t } = useTranslation();
  const { mixAndMatch } = values;
  const { currencyFormat } = useBusinessContext();
  const [inputFieldsCourse, setInputFieldsCourse] = useState(mixAndMatch || []);
  let max = 0;
  let min = 0;

  if (values.minPrice !== undefined) {
    Object.values(values.minPrice).forEach((item) => {
      min += item;
    });
  }

  if (values.maxPrice !== undefined) {
    Object.values(values.maxPrice).forEach((item) => {
      max += item;
    });
  }

  const handleAddStep = () => {
    setInputFieldsCourse({
      ...inputFieldsCourse,
      steps: [
        ...inputFieldsCourse.steps,
        {
          name: "",
          items: [
            {
              items: [],
              quantity: "1",
              price: "",
            },
          ],
        },
      ],
    });

    values.mixAndMatch.steps = [
      ...values.mixAndMatch.steps,
      {
        name: "",
        items: [
          {
            items: [],
            quantity: "1",
            price: "",
          },
        ],
      },
    ];
  };

  const handleRemoveStep = (index) => {
    setInputFieldsCourse({
      ...inputFieldsCourse,
      steps: inputFieldsCourse.steps.filter((_, i) => i !== index),
    });
    setFieldValue(
      "mixAndMatch.steps",
      values.mixAndMatch.steps.filter((_, i) => i !== index)
    );
  };

  const handleAddItem = (index) => {
    setInputFieldsCourse({
      ...inputFieldsCourse,
      steps: inputFieldsCourse.steps.map((step, i) => {
        if (i === index) {
          return {
            ...step,
            items: [
              ...step.items,
              {
                items: [],
                quantity: "1",
                price: "",
              },
            ],
          };
        }
        return step;
      }),
    });

    values.mixAndMatch.steps = values.mixAndMatch.steps.map((step, i) => {
      if (i === index) {
        return {
          ...step,
          items: [
            ...step.items,
            {
              items: [],
              quantity: "1",
              price: "",
            },
          ],
        };
      }
      return step;
    });
  };

  const handleRemoveItem = (ind, index) => {
    setInputFieldsCourse({
      ...inputFieldsCourse,
      steps: inputFieldsCourse.steps.map((step, i) => {
        if (i === ind) {
          return {
            ...step,
            items: step.items.filter((_, i) => i !== index),
          };
        }
        return step;
      }),
    });
    setFieldValue(
      "mixAndMatch.steps",
      values.mixAndMatch.steps.map((step, i) => {
        if (i === ind) {
          return {
            ...step,
            items: step.items.filter((_, i) => i !== index),
          };
        }
        return step;
      })
    );
  };

  return (
    <>
      {inputFieldsCourse?.steps?.map((inputField, i) => (
        <s.Wrapper key={i}>
          <s.SectionTitle>
            <s.Title>
              {" "}
              {`${t("Items.fields.mixAndMatch.course")} ${i + 1} `}
            </s.Title>
            {inputFieldsCourse.steps.length > 1 && (
              <s.deleteCourse onClick={() => handleRemoveStep(i)}>
                {t("Items.fields.mixAndMatch.deleteCourse")}
              </s.deleteCourse>
            )}
          </s.SectionTitle>
          <s.Line style={{ marginBottom: "10px" }} />
          <Row>
            <Col span={5}>
              <s.SubTitle>
                {t("Items.fields.mixAndMatch.selectItem")}
              </s.SubTitle>
            </Col>
            <Col span={5} />
            <Col span={6} />
            <Col span={3}>
              <s.SubTitle>{t("Items.fields.mixAndMatch.extraCost")}</s.SubTitle>
            </Col>
            <Col span={3}>
              <s.SubTitle>{t("Items.fields.mixAndMatch.units")}</s.SubTitle>
            </Col>
            <Col span={2} />
          </Row>
          {inputField.items.map((item, index) => (
            <ItemsCourse
              key={index}
              values={values}
              i={i}
              index={index}
              item={item}
              items={items}
              courseId={inputField.id}
              handleRemoveItem={handleRemoveItem}
              setFieldValue={setFieldValue}
              errors={errors}
            />
          ))}
          <s.deleteCourse onClick={() => handleAddItem(i)}>
            {t("Items.fields.mixAndMatch.addItemCourse")}
          </s.deleteCourse>
        </s.Wrapper>
      ))}
      <s.ButtonaddCourse onClick={handleAddStep}>
        <Plus />
        <s.addCourseText>
          {t("Items.fields.mixAndMatch.addCourse")}
        </s.addCourseText>
      </s.ButtonaddCourse>

      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "53px" }}
      >
        <s.SubTitle style={{ marginRight: "46px" }}>
          {t("Items.fields.mixAndMatch.minPrice")}

          {min === "Infinity"
            ? "0"
            : min === "-Infinity"
            ? "0"
            : currencyFormat(min)}
        </s.SubTitle>
        <s.SubTitle>
          {t("Items.fields.mixAndMatch.maxPrice")}

          {max === "Infinity"
            ? "0"
            : max === "-Infinity"
            ? "0"
            : currencyFormat(max)}
        </s.SubTitle>
      </div>
    </>
  );
}

export default Mix_Match;
